'use client';

import styled from 'styled-components';
import { colors } from '../../Colors/index.js';

var PricingInfoWrapper = styled.div({
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '18px'
});
var PricingInfoContainer = styled.div({
    padding: '12px 0',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: 12
});
var ImageWrapper = styled.div({
    width: 62,
    height: 62,
    padding: 6,
    border: "1px solid ".concat(colors.neutral[90]),
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain'
    }
});
var PricingInfoSection = styled.div({
    display: 'grid',
    rowGap: 4
});
var LimitTextLine = styled.span(function (_a) {
    var _b = _a.limitLine, limitLine = _b === void 0 ? 1 : _b;
    return ({
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '20px',
        marginBottom: 0,
        wordBreak: 'break-word',
        overflow: 'hidden',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: limitLine
    });
});
var CompanyText = styled.p({
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 400
});
var SalaryText = styled.span({
    color: colors.secondary[40]
});
var Text = styled.p({
    margin: 0
});
var List = styled.ul({
    display: 'grid',
    rowGap: 16,
    margin: 0,
    padding: 0,
    '& > li': {
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        columnGap: 11,
        '& > svg': {
            marginTop: 2
        }
    }
});
var PricingSection = styled.div({});
var PricingText = styled.div({
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    lineHeight: '14px',
    fontWeight: 400,
    '& p': {
        margin: '0 12px 0 0',
        '& > .highlight': {
            fontSize: 14,
            lineHeight: '18px'
        }
    }
});
var FreeTrialText = styled.div({
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '24px',
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    marginTop: -2,
    '& > svg': {
        marginTop: 1
    },
    '& > .highlight': {
        margin: '0 4px 0 0',
        background: 'linear-gradient(90deg, #FE8323 0%, #FF3C68 50%, #DC1EAF 75%, #B300D7 100%)',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
    }
});

export { CompanyText, FreeTrialText, ImageWrapper, LimitTextLine, List, PricingInfoContainer, PricingInfoSection, PricingInfoWrapper, PricingSection, PricingText, SalaryText, Text };
//# sourceMappingURL=styles.js.map
